import { FormElement, formService } from '@common';
import { useSharedApi } from './lib/api/shared.api';
import { EmailValidator } from './lib/modules/base/validators/email.validator';
import { PhoneNumberValidator } from './lib/modules/base/validators/phone-number.validator';
import { AxialCropNameField, AxialZoneStrengthParcelOrderStatus } from './lib/modules/crop';
import { AxialBlockedByField, HasTenderField, ParcelNameField } from './lib/modules/parcel';
import { HasOrderField } from './lib/modules/order';

// api
export * from './lib/api/shared.api';

// modules
export * from './lib/modules/auth';
export * from './lib/modules/base';
export * from './lib/modules/html-content';
export * from './lib/modules/crop';
export * from './lib/modules/order';
export * from './lib/modules/offer';
export * from './lib/modules/parcel';
export * from './lib/modules/proplanta';
export * from './lib/modules/wizard';
export * from './lib/modules/offer-calculator';

// i18n
export * from './i18n';

// register form related stuff
formService.setAutocompleteApi(useSharedApi().autocomplete);
formService.registerValidator('email', EmailValidator);
formService.registerValidator('phoneNumber', PhoneNumberValidator);

formService.registerFormElement('cropNameField', {
  class: FormElement,
  componentClass: AxialCropNameField
});
formService.registerFormElement('blockedByField', {
  class: FormElement,
  componentClass: AxialBlockedByField
});
formService.registerFormElement('hasTenderField', {
  class: FormElement,
  componentClass: HasTenderField
});
formService.registerFormElement('parcelNameField', {
  class: FormElement,
  componentClass: ParcelNameField
});
formService.registerFormElement('hasOrderField', {
  class: FormElement,
  componentClass: HasOrderField
});
formService.registerFormElement('zoneStrengthParcelOrderStatus', {
  class: FormElement,
  componentClass: AxialZoneStrengthParcelOrderStatus
});
